import React from 'react';
import { DatesProvider } from '@mantine/dates';
import 'dayjs/locale/id';

interface MantineDateProvidersProps {
  children: React.ReactNode;
}

const MantineDateProviders: React.FC<MantineDateProvidersProps> = ({ children }) => {
  return <DatesProvider settings={{ locale: 'id' }}>{children}</DatesProvider>;
};

export default MantineDateProviders;
